export default __webpack_public_path__ + "static/media/black-front.e02c14e3.png";